import { colors } from '../../colors';
var header = {
  primaryColor: colors.lead,
  hoverColor: colors.cornflowerBlue,
  borderColor: colors.overcast,
  bgColor: colors.white,
  barColor: colors.lead,
  navContactLinkHoverTextDecoration: "underline",
  navUtilityLinkColor: colors.lead,
  navUtilityLinkHoverColor: colors.lead,
  navUtilityLinkTextDecoration: "none",
  navUtilityLinkHoverTextDecoration: "underline",
  topNavLineHeight: '16px'
};
export default header;